export enum State{
    BAD_STATUS_GIVEN = -1,
    NOT_LOGGED = 0,
    CHOSE_MODE = 1,
    GAME = 2,
    WAITING_FOR_HELP = 3,
    CREATING_NEW_GAME = 4,
    BAD_LOGIN = 5,
    RECREATING_DISCONNECTED_GAME = 6,
    WAITING_FOR_REMATCH = 7,
    /**
     * zamknięty fizycznie przez adminow - ten stan jest po wyslaniu wiadomosci.
     */
    SERVER_WAS_CLOSED = 8,
    OPTION_VIEW  = 9,
    WAIT_FOR_APPLY_OPTION = 10,
    APPLYING_OPTION = 11,
    WAITING_FOR_CHECK = 12,
    SENDING_LOGIN = 13,
    WAITING_FOR_FRIENDS_PERMISSION = 14,
    WAITING_FOR_FRIENDS_LIST_FOM_SERVER = 15,
    CHOOSING_FRIENDS = 16,
    WEEKLY_RANKING_RESULT_WINDOW = 17,
    WEEKLY_RANKING_RESULT_WINDOW_WAIT = 18,
    WEEKLY_RANKING_RESULT_WAIT_FOR_PERMISSION = 19,		
    ACHIEVEMENT_WINDOW_WAIT = 20,
    ALL = 21,
    BUYING_PERMISSION = 22,
	BUYING_BOOSTS = 23
	
}
/*
namespace State {
    export function getIntState(s:State):number {
		switch (s)
		{
			case State.NOT_LOGGED: return 0;
			case State.CHOSE_MODE: return 1;
			case State.GAME: return 2;
			case State.WAITING_FOR_HELP: return 3;
			case State.CREATING_NEW_GAME: return 4;
			case State.BAD_LOGIN: return 5;
			case State.RECREATING_DISCONNECTED_GAME: return 6;
			case State.WAITING_FOR_REMATCH: return 7;
			case State.SERVER_WAS_CLOSED: return 8;
			case State.OPTION_VIEW: return 9;
			case State.WAIT_FOR_APPLY_OPTION: return 10;
			case State.APPLYING_OPTION: return 11;
			case State.WAITING_FOR_CHECK: return 12;
			case State.SENDING_LOGIN: return 13;
			case State.WAITING_FOR_FRIENDS_PERMISSION: return 14;
			case State.WAITING_FOR_FRIENDS_LIST_FOM_SERVER: return 15;
			case State.CHOOSING_FRIENDS: return 16;
			case State.WEEKLY_RANKING_RESULT_WINDOW: return 17;
			case State.WEEKLY_RANKING_RESULT_WINDOW_WAIT: return 18;
			case State.WEEKLY_RANKING_RESULT_WAIT_FOR_PERMISSION: return 19;
			case State.ACHIEVEMENT_WINDOW_WAIT: return 20;
			case State.ALL: return 21;
			case State.BUYING_PERMISSION: return 22;
			case State.BUYING_BOOSTS: return 23;
		};
		return -1;
	}
		
	export function getStringStatus(s:number):State {
		switch (s)
		{ 
			case 0: return State.NOT_LOGGED;
			case 1: return State.CHOSE_MODE;
			case 2: return State.GAME;
			case 3: return State.WAITING_FOR_HELP;
			case 4: return State.CREATING_NEW_GAME;
			case 5: return State.BAD_LOGIN;
			case 6: return State.RECREATING_DISCONNECTED_GAME;
			case 7: return State.WAITING_FOR_REMATCH;
			case 8: return State.SERVER_WAS_CLOSED;
			case 9: return State.OPTION_VIEW;
			case 10: return State.WAIT_FOR_APPLY_OPTION;
			case 11: return State.APPLYING_OPTION;
			case 12: return State.WAITING_FOR_CHECK;
			case 13: return State.SENDING_LOGIN;
			case 14: return State.WAITING_FOR_FRIENDS_PERMISSION;
			case 15: return State.WAITING_FOR_FRIENDS_LIST_FOM_SERVER;
			case 16: return State.CHOOSING_FRIENDS;
			case 17: return State.WEEKLY_RANKING_RESULT_WINDOW;
			case 18: return State.WEEKLY_RANKING_RESULT_WINDOW_WAIT;
			case 19: return State.WEEKLY_RANKING_RESULT_WAIT_FOR_PERMISSION;
			case 20: return State.ACHIEVEMENT_WINDOW_WAIT;
			case 21: return State.ALL;
			case 22: return State.BUYING_PERMISSION;
			case 23: return State.BUYING_BOOSTS;
		};
		return State.BAD_STATUS_GIVEN;
	}
} */